// extracted by mini-css-extract-plugin
export default {"container":"mUsT5ejcaidNOB4CeRmC","divider":"hjB2pFdGF_uTp4QWtJrC","logoBox":"_V0J84lLY4TqfxsgFhj1"};